import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var LensDefaultIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M23.13,12H22a4.47,4.47,0,0,0-8.43-1.58A3,3,0,0,0,12,10a3,3,0,0,0-1.53.43A4.47,4.47,0,0,0,2.09,12H1a.5.5,0,1,0,0,1h1a4.49,4.49,0,0,0,9-.5,4.33,4.33,0,0,0-.15-1.08A2.44,2.44,0,0,1,12,11.11a2.4,2.4,0,0,1,1.14.31A4.84,4.84,0,0,0,13,12.5,4.49,4.49,0,0,0,22,13h1.14a.5.5,0,0,0,0-1Z"
  }), /*#__PURE__*/_jsx("circle", {
    cx: "6.54",
    cy: "12.5",
    r: "3.5",
    fill: "#fff"
  }), /*#__PURE__*/_jsx("circle", {
    cx: "17.54",
    cy: "12.5",
    r: "3.5",
    fill: "#fff"
  })]
}), 'LensDefaultIcon');